import { useEffect } from 'react';

const DEFAULT_TITLE = 'RedGoTrip | Holidays, Packages, Camping & Destinations';
const DEFAULT_DESCRIPTION = 'Explore tour packages, camping stays, destinations, deals and travel support with RedGoTrip.';
const SITE_NAME = 'RedGoTrip';
const DEFAULT_IMAGE = 'https://redgotrips.com/logo192.png';

const upsertMeta = (selector, attributes) => {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('meta');
        document.head.appendChild(element);
    }

    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
};

const upsertLink = (selector, attributes) => {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('link');
        document.head.appendChild(element);
    }

    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
};

const upsertJsonLd = (id, data) => {
    let script = document.head.querySelector(`#${id}`);

    if (!data) {
        if (script) script.remove();
        return;
    }

    if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = id;
        document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);
};

const buildCanonicalUrl = (path) => {
    const base = window.location.origin || 'https://redgotrips.com';
    return `${base}${path || window.location.pathname}${window.location.search || ''}`;
};

const SEO = ({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    canonicalPath = '',
    image = DEFAULT_IMAGE,
    type = 'website',
    keywords = '',
    jsonLd = null
}) => {
    useEffect(() => {
        const finalTitle = title || DEFAULT_TITLE;
        const finalDescription = description || DEFAULT_DESCRIPTION;
        const finalCanonical = buildCanonicalUrl(canonicalPath);
        const finalImage = image || DEFAULT_IMAGE;

        document.title = finalTitle;

        upsertMeta('meta[name="description"]', { name: 'description', content: finalDescription });
        upsertMeta('meta[name="keywords"]', { name: 'keywords', content: keywords });
        upsertMeta('meta[property="og:title"]', { property: 'og:title', content: finalTitle });
        upsertMeta('meta[property="og:description"]', { property: 'og:description', content: finalDescription });
        upsertMeta('meta[property="og:type"]', { property: 'og:type', content: type });
        upsertMeta('meta[property="og:url"]', { property: 'og:url', content: finalCanonical });
        upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE_NAME });
        upsertMeta('meta[property="og:image"]', { property: 'og:image', content: finalImage });
        upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
        upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: finalTitle });
        upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: finalDescription });
        upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: finalImage });
        upsertLink('link[rel="canonical"]', { rel: 'canonical', href: finalCanonical });
        upsertJsonLd('redgotrip-jsonld', jsonLd);
    }, [canonicalPath, description, image, jsonLd, keywords, title, type]);

    return null;
};

export default SEO;
